var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkageCircleChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(-673 -412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168",
    transform: "translate(-17.164 -73.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    transform: "translate(690.164 485.279)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 10.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Union_40",
    "data-name": "Union 40",
    d: "M1.949,7.543h0L0,5.657,1.3,4.4,3.248,6.286,9.742,0l1.3,1.257L4.547,7.542h0L3.248,8.8Z",
    transform: "translate(678.959 419.1)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkageCircleChecked);
export default __webpack_public_path__ + "static/media/linkage-circle-checked.7e884779151a086b3d0dd04acd33648a.svg";
export { ForwardRef as ReactComponent };